/**
 * Converte um arquivo para base64 **sem** o prefixo `data:...;base64,`.
 *
 * Use esta versão para envio à API, que espera o payload raw.
 * Para preview local em `<img src>`, use `fileToBase64WithPrefix`.
 */
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64Data = (reader.result as string).split(",")[1];
      resolve(base64Data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

/**
 * Converte um arquivo para data URL completa (`data:image/...;base64,...`).
 *
 * Use para alimentar o atributo `src` de `<img>` em previews locais.
 * Para envio à API, use `fileToBase64`.
 */
export const fileToBase64WithPrefix = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const isValidImageFile = (file: File): boolean =>
  file.type.startsWith("image/");

export const isValidFileSize = (file: File, maxSizeInMB: number): boolean =>
  file.size <= maxSizeInMB * 1024 * 1024;
